import {
  DateValue,
  parseDate,
} from '@internationalized/date';

import { ValidationResultT } from '../types';
import {
  getDigitsOnly,
  isDefined,
  today,
} from '../utils';

export const ssnRequiredMessage = 'Enter your Social Security number.';
export const ssnInvalidMessage = 'Enter your 9-digit Social Security number.';
export const dobInvalidMessage = 'Enter your date of birth in this format: MM/DD/YYYY.';
export const dobUnderRequiredAgeMessage = 'You must be 18 years or older to apply for a loan.';

export const invalidDateOfBirth = parseDate('1900-01-01');

export const getUnderRequiredAgeDob = (): DateValue => {
  return today().add({ years: -18 });
};

export const isValidSsn = (ssnDigits: string): boolean => {
  if (ssnDigits.length !== 9) { return false; }

  if (ssnDigits.startsWith('666') || ssnDigits.startsWith('9')) { return false; }

  if (ssnDigits === '123456789') { return false; }

  if (/^(\d)\1{8}$/.test(ssnDigits)) { return false; }

  const areaNumber = ssnDigits.slice(0, 3);
  const groupNumber = ssnDigits.slice(3, 5);
  const serialNumber = ssnDigits.slice(5);

  if (areaNumber === '000' || groupNumber === '00' || serialNumber === '0000') { return false; }

  return true;
};

export const validateSsn = (value: string): ValidationResultT => {
  return isValidSsn(getDigitsOnly(value)) ? true : ssnInvalidMessage;
};

export const validateDob = (dateOfBirth: DateValue | undefined): ValidationResultT => {
  if (!isDefined(dateOfBirth)) { return dobInvalidMessage; }

  if (dateOfBirth.compare(invalidDateOfBirth) <= 0) { return dobInvalidMessage; }

  if (dateOfBirth.compare(getUnderRequiredAgeDob()) > 0) { return dobUnderRequiredAgeMessage; }

  return true;
};
